module.exports = __webpack_public_path__ + "img/auditing.c72db0de.png";